import axios from 'axios';
// 创建请求实例
const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  // withCredentials: true,
  timeout: 300000, // 超时10分钟
});

instance.interceptors.request.use(
  config => {
    config.st = +new Date();
    return config;
  },
  err => Promise.reject(err),
);
instance.interceptors.response.use(
  response => response,
  err => {
    const { message: msg, response, config } = err;
    const {
      url,
      method,
      baseURL,
      data: _data = {},
      params: _params = {},
      st = 0,
    } = config;
    const rt = +new Date() - st;
    const data = {
      url: url.replace(baseURL, ''),
      md: method,
      mg: msg.slice(0, 500),
      code: 'no',
      rt,
      cext: { data: _data, params: _params },
    };
    if (response) {
      data.code = response.status;
      data.mg = (response.data.error || '').slice(0, 500);
    }
    window.tracker && window.tracker.sendError('xhr', data);
    return Promise.reject(err);
  },
);

const get = function get(url, params, config = {}) {
  return instance.get(url, { params, ...config });
};

export default {
  get,
};
